import { useMapsLibrary } from '@vis.gl/react-google-maps';
import React, { useEffect, useRef, useState } from 'react';
import '../geofence.css'
import { Box, TextField } from '@material-ui/core';

interface MapSearchProps {
  searchAddressResult?: any | null;
  onPlaceSelect: (placeResult: google.maps.places.PlaceResult) => void;
  componentRestrictions?: google.maps.places.ComponentRestrictions | undefined;
  clearSearch?: boolean; // If true, clear the search input field
}

const countries = {
  'ca': 'Canada',
  'us': 'United States',
}

const MapSearch: React.FC<MapSearchProps> = ({ searchAddressResult, onPlaceSelect, componentRestrictions, clearSearch }) => {
  const [placeAutocomplete, setPlaceAutocomplete] =
    useState<google.maps.places.Autocomplete | null>(null);
  const [inputValue, setInputValue] = useState<string>('');
  const inputRef = useRef<HTMLInputElement>(null);
  const places = useMapsLibrary('places');

  useEffect(() => {
    if (!places || !inputRef.current) return;

    const options = {
      fields: ['geometry', 'name', 'formatted_address'],
      componentRestrictions: componentRestrictions || undefined
    };

    setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
  }, [places, searchAddressResult]);

  useEffect(() => {
    if (!placeAutocomplete) return;

    placeAutocomplete.addListener('place_changed', () => {
      const place = placeAutocomplete.getPlace();
      setInputValue(place.formatted_address || '');
      onPlaceSelect(place); // Notify parent component
    });
  }, [onPlaceSelect, placeAutocomplete]);

  // Update input value when searchAddressResult changes
  useEffect(() => {
    if (searchAddressResult) {
      setInputValue(searchAddressResult.formattedAddress || '');
    }
  }, [searchAddressResult]);

  // Clear input when clearSearch prop is true
  useEffect(() => {
    if (clearSearch) {
      setInputValue('');
    }
  }, [clearSearch]);

  return (
    <Box
      className="autocomplete-container"
      sx={{
        display: 'flex',
        width: '100%',
      }}
    >
      <TextField
        inputRef={inputRef}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder="Enter search location address..."
        fullWidth
        variant="outlined"
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        }}
      />
    </Box>
  );
};

export default React.memo(MapSearch);
